/**
 * @generated SignedSource<<a3bddacb05a07ce1c13be9d36325162a>>
 * @relayHash 49bef82d4f0cba5fb1b71e216bfacc6c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 67a0a7c3c3341e515d135166d0a40d92c4271e5e21627431f1ea80f4ac6d14ac

import type { ConcreteRequest, Query } from 'relay-runtime';
export type LabelsQuerySpaceDirectoryLabelsQuery$variables = {
  start?: number | null | undefined;
};
export type LabelsQuerySpaceDirectoryLabelsQuery$data = {
  readonly teamLabels: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type LabelsQuerySpaceDirectoryLabelsQuery = {
  response: LabelsQuerySpaceDirectoryLabelsQuery$data;
  variables: LabelsQuerySpaceDirectoryLabelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "start"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      },
      {
        "kind": "Variable",
        "name": "start",
        "variableName": "start"
      }
    ],
    "concreteType": "PaginatedLabelList",
    "kind": "LinkedField",
    "name": "teamLabels",
    "plural": false,
    "selections": [
      {
        "concreteType": "Label",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LabelsQuerySpaceDirectoryLabelsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LabelsQuerySpaceDirectoryLabelsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "49bef82d4f0cba5fb1b71e216bfacc6c",
    "id": "67a0a7c3c3341e515d135166d0a40d92c4271e5e21627431f1ea80f4ac6d14ac",
    "metadata": {},
    "name": "LabelsQuerySpaceDirectoryLabelsQuery",
    "operationKind": "query",
    "text": "query LabelsQuerySpaceDirectoryLabelsQuery($start:Int){teamLabels(start:$start,first:200){nodes{name,id},pageInfo{hasNextPage}}}"
  }
};
})();

(node as any).hash = "a3edf32f3d3466047f9c0335a0728c6a";

export default node;
